import { render, staticRenderFns } from "./VoteListComponent.vue?vue&type=template&id=2b9486d7&scoped=true"
import script from "./VoteListComponent.vue?vue&type=script&lang=js"
export * from "./VoteListComponent.vue?vue&type=script&lang=js"
import style0 from "./VoteListComponent.vue?vue&type=style&index=0&id=2b9486d7&prod&lang=css"
import style1 from "./VoteListComponent.vue?vue&type=style&index=1&id=2b9486d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9486d7",
  null
  
)

export default component.exports